import React, { Component } from 'react'
import {VideoStyle} from './../styles'
import { Triangle } from './'

export default class Video extends Component {
  state = {
    active: false,
  }

  handlerClick = (e) => {
    e.preventDefault()
    this.setState({ url: this.props.type === 'vimeo' ? `https://player.vimeo.com/video/${this.props.link}` : `https://www.youtube.com/embed/${this.props.link}`}, () => {
      this.setState({ active: true })
      document.querySelector('.app-body').scrollIntoView()
    })
  }

  handlerClose = (e) => {
    e.preventDefault()
    this.setState({ active: false}, () => {
      this.setState({ url: '' })
    })
  }

  render() {
    const { title, poster, label } = this.props
    return (
      <div className={`video-container ${VideoStyle(poster, this.state.active)}`}>
        <div className="video" onClick={this.handlerClick}>
          <button className="btn btn--play">
            <Triangle width={12} height={12} /> { label }
          </button>
        </div>
        { title && <span className="video-label">{ title }</span> }
        <div className="video-container-full">
          <button className="video-close" onClick={this.handlerClose}>
            <span></span>
            <span></span>
          </button>
          <div className="video-iframe">
              <iframe src={this.state.url} frameBorder="0" allowFullScreen title={ title || 'Video iframe'  }></iframe> 
          </div>
        </div>  
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Video.js